import FavoriteIcon from '@mui/icons-material/Favorite';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Box, Button, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import React from 'react';

export default function FreeTrialBanner() {

    return (
        <Box
            sx={{
                py: 8,
                background: 'white',
            }}
        >
            <Container maxWidth="lg">
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    <Box
                        sx={{
                            p: { xs: 3, md: 4 },
                            background: 'linear-gradient(135deg, #ff6600 0%, #ff8533 50%, #ff6600 100%)',
                            borderRadius: '20px',
                            color: 'white',
                            textAlign: 'center',
                            position: 'relative',
                            overflow: 'hidden',
                            boxShadow: '0 10px 30px rgba(255, 102, 0, 0.3)',
                            border: '3px solid #ff8533',
                        }}
                    >
                        {/* Arka plan animasyonu */}
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 70%)',
                                zIndex: 0,
                            }}
                        />

                        <Box sx={{ position: 'relative', zIndex: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                                <motion.div
                                    animate={{
                                        scale: [1, 1.2, 1],
                                    }}
                                    transition={{
                                        duration: 1,
                                        repeat: Infinity,
                                        ease: "easeInOut"
                                    }}
                                >
                                    <FavoriteIcon sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mr: 1, color: '#fff' }} />
                                </motion.div>
                                <Typography
                                    variant="h3"
                                    component="h3"
                                    sx={{
                                        fontSize: { xs: '1.8rem', md: '2.5rem' },
                                        fontWeight: 800,
                                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                                    }}
                                >
                                    3 GÜN ÜCRETSİZ DENEME
                                </Typography>
                            </Box>

                            <Typography
                                variant="h6"
                                sx={{
                                    fontSize: { xs: '1rem', md: '1.3rem' },
                                    mb: 3,
                                    fontWeight: 500,
                                    opacity: 0.95,
                                }}
                            >
                                TrendAsist'i risk almadan deneyin! Hiçbir ödeme yapmadan 3 gün boyunca tüm özelliklerden yararlanın.
                            </Typography>

                            <motion.div
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                <Button
                                    variant="contained"
                                    size="large"
                                    startIcon={<WhatsAppIcon />}
                                    component="a"
                                    href="https://wa.me/905315404669?text=Merhaba%2C%203%20gün%20ücretsiz%20deneme%20için%20demo%20kurulumu%20talep%20ediyorum."
                                    target="_blank"
                                    sx={{
                                        backgroundColor: '#fff',
                                        color: '#ff6600',
                                        py: { xs: 1.5, md: 2 },
                                        px: { xs: 3, md: 4 },
                                        fontSize: { xs: '1rem', md: '1.2rem' },
                                        fontWeight: 700,
                                        borderRadius: '50px',
                                        boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                                        '&:hover': {
                                            backgroundColor: '#f5f5f5',
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 12px 25px rgba(0,0,0,0.3)',
                                        },
                                        transition: 'all 0.3s ease',
                                    }}
                                >
                                    Demo Kurulumu Talep Et
                                </Button>
                            </motion.div>

                            <Typography
                                variant="body2"
                                sx={{
                                    mt: 2,
                                    fontSize: { xs: '0.8rem', md: '0.9rem' },
                                    opacity: 0.9,
                                    fontStyle: 'italic',
                                }}
                            >
                                ⚡ Kurulum sadece 5 dakika • Kredi kartı gerekmez • İstediğiniz zaman iptal edebilirsiniz
                            </Typography>
                        </Box>
                    </Box>
                </motion.div>
            </Container>
        </Box>
    );
} 